import type { RootState } from "../store"

export const networkStatusSelector = (state: RootState) => state.networkStatus
